<div class="my-limegear-large-card-container">
    <large-card [largeCardInteriorOptions]="this.chartCardInfo.largeCardInteriorOptions"></large-card>
</div>